import { subscribe } from '../../common/errors/sagas';
import { notificationError } from '../../common/errors/notificationTypes';

const pre = 'IMPACTANALYSIS/IDSUMMARY/';

export const INITIALISE = `${pre}INITIALISE`;
export const SET_INITIALISED = `${pre}SET_INITIALISED`;
export const SEARCH_ID_REQUEST = `${pre}SEARCH_ID_REQUEST`;
export const SEARCH_ID_ERROR = `${pre}SEARCH_ID_ERROR`;
export const SET_IMPACT_ID = `${pre}SET_IMPACT_ID`;
export const INCORRECT_IMPACT_ID = `${pre}INCORRECT_IMPACT_ID`;
export const SET_SUMMARY_TRADES = `${pre}SET_SUMMARY_TRADES`;
export const SET_SUMMARY_IMPACT_ROWS = `${pre}SET_SUMMARY_IMPACT_ROWS`;
export const SET_PRICING_PARAMETERS = `${pre}SET_PRICING_PARAMETERS`;

subscribe(SEARCH_ID_ERROR, 'An error occured when searching for the Impact Analysis Id', notificationError);
subscribe(INCORRECT_IMPACT_ID, 'An error occured when searching for the Impact Analysis Id', notificationError);

export const initialise = () => ({
    type: INITIALISE
});

export const setInitialised = () => ({
    type: SET_INITIALISED
});

export const searchIdRequest = id => ({
    type: SEARCH_ID_REQUEST,
    id
});

export const SearchIdError = error => ({
    type: SEARCH_ID_ERROR,
    error
});

export const setImpactAnalysisId = id => ({
    type: SET_IMPACT_ID,
    id
});

export const incorrectImpactId = error => ({
    type: INCORRECT_IMPACT_ID,
    error
});

export const setSummaryTradesPricedToday = trades => ({
    type: SET_SUMMARY_TRADES,
    trades
});

export const setSummaryImpactSummaryRows = data => ({
    type: SET_SUMMARY_IMPACT_ROWS,
    data
});

export const setPricingParams = data => ({
    type: SET_PRICING_PARAMETERS,
    data
});
